import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfo } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfo';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetEngagement } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor;
  basicInfo?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfo;
  engagement?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetEngagement;
};
